/** Enhance a react component to contain and display a toggle-able menu.
 * Makes available `toggleMenu :: () -> ()` and `showMenu :: Bool` props.
 */

import { withStateHandlers, lifecycle, compose } from 'recompose'

const withMenuToggle = withStateHandlers(
  { showMenu: false },
  {
    toggleMenu: ({ showMenu }) => forceState => ({
      showMenu:
        typeof forceState === 'boolean'
          ? forceState // Only if not event handler callback
          : !showMenu
    })
  }
)

const withCloseOnOutsideClick = lifecycle({
  componentWillReceiveProps(nextProps) {
    if (typeof document !== 'undefined') {
      // If menu was just shown, register close handler
      if (!this.props.showMenu && nextProps.showMenu && nextProps.toggleMenu != null) {
        document.addEventListener('click', nextProps.toggleMenu)
      }
      // If menu was just hidden, unregister close handler
      if (this.props.showMenu && !nextProps.showMenu && nextProps.toggleMenu != null) {
        document.removeEventListener('click', nextProps.toggleMenu)
      }
    }
  }
})

export default compose(
  withMenuToggle,
  withCloseOnOutsideClick
)



// WEBPACK FOOTER //
// ./src/common/ui/common/withMenuToggle.js